import { Injectable } from '@angular/core';
import {
    HttpClient,
    HttpHeaders,
    HttpRequest,
    HttpParams
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { CookieHelperService } from '../../../shared/services/cookie-helper.service';
import { FileUploader } from '../../../api/models/file-uploader';
import {
    DealStipulations,
    DealStipulationsResponse
} from '../../../api/models/deal-stipulations';

@Injectable()
export class StipulationService {
    private _ajaxUrl = '/wp-admin/admin-ajax.php';
    private _action = 'wfs_direct_ajax';

    constructor(
        private http: HttpClient,
        private cookieService: CookieHelperService
    ) {}

    getDealStipulation(genesisId): Observable<DealStipulations[]> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded'
        });

        const httpOptions = {
          headers,
          reportProgress: true
        };

        const params = new HttpParams()
            .set('genesisId', genesisId)
            .set('request_type', 'getDealStipulations')
            .set('action', this._action);

        return this.http
            .post(this._ajaxUrl, params.toString(), httpOptions)
            .map(this.mapStipulation);
    }

    uploadDocument(fileUploader: FileUploader, genesisId) {
        const headers = new HttpHeaders();
        headers.set('Content-Type', 'multipart/form-data');

        const httpOptions = {
            headers,
            reportProgress: true
        };

        const req = new HttpRequest(
            'POST',
            this._ajaxUrl,
            this.formData(fileUploader, genesisId),
            httpOptions
        );
        return this.http.request(req);
    }

    private formData(fileUploader: FileUploader, genesisId): FormData {
        const form = new FormData();
        form.append('action', this._action);
        form.append('request_type', 'uploadDocument');
        form.append('StipulationTypeId', String(fileUploader.stipulationId));
        form.append('DealId', genesisId);

        for (const document of fileUploader.document) {
            form.append('DocumentData', document);
        }
        return form;
    }

    private mapStipulation(response: DealStipulationsResponse) {
        return response.data.DealStipulationsDTOs.map(
            (dealStip: DealStipulations) => {
                return dealStip;
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/customer-account/services/stipulation.service.ts